import { render } from "./ModalTable.vue?vue&type=template&id=0ea83064"
import script from "./ModalTable.vue?vue&type=script&lang=js"
export * from "./ModalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__